module.exports = __webpack_public_path__ + "static/media/home-slide-3.70fdb571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MainImage/home-slide-3.jpg
// module id = 338
// module chunks = 0